module.exports = "/images/breeze.svg?54cc18bd24ee7141f13c25ba307d7eb2";